import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Alert, Button, Space} from 'antd';
import {connect} from 'react-redux';
import {Collapse} from 'react-collapse';
import {CloseOutlined} from '@ant-design/icons';
import {
  StyledInvoiceUploader,
  StyledInvoiceUploaderListSpace
} from './StyledInvoiceUploader';
import Upload from '../../../Upload';
import {fileHelpers} from '../../../../utils/helpers';
import {FileInvoiceIcon} from '../../../../icons';
import {invoicesActions} from '../../../../state/actions/invoice.actions';

const InvoiceUploader = ({
  dispatch,
  batchCreateInvoices,
  batchDeleteInvoices,

  onChange,
  size,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const [files, setFiles] = useState([]);
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState(null);

  const isUploadedFiles = useMemo(() => Boolean(files.length), [files]);

  const clearError = () => {
    if (error) setError(null);
  }

  const handleOnFileChange = async ({fileList}) => {
    let createdFiles = [];
    for (const file of fileList) {
      const fileBase64 = await fileHelpers.getBase64(file.originFileObj);
      createdFiles.push({
        date: new Date(),
        file: fileBase64,
        name: file.name
      });
    }
    setFiles([...files, ...createdFiles]);
    clearError();

    await handleAddInvoice(createdFiles[0]);
  }

  const errorCallbackFunction = (error) => setError(error?.message || error);

  const handleAddInvoice = async (file) => {
    if (!file) return;

    batchCreateInvoices(
      {invoices: [{base64_file: file.file, file_name: file.name}]},
      (invoices) => {
        const invoice = invoices[0];
        setInvoice(invoice);
        onChange && onChange(invoice);
      },
      errorCallbackFunction
    );
  }

  const handleDeleteInvoice = () => {
    const id = invoice?.id;
    if (!id) return;

    batchDeleteInvoices(
      [id],
      () => {
        setInvoice(null);
        onChange && onChange([]);
      },
      errorCallbackFunction
    );
  }

  const handleRemoveFile = (index) => {
    const copyFiles = [...files];
    copyFiles.splice(index, 1);
    setFiles(copyFiles);
    clearError();

    handleDeleteInvoice();
  }

  return (
    <StyledInvoiceUploader
      direction='vertical'
      {...rest}
    >
      {!isUploadedFiles ? (
        <Upload
          accept='.jpeg,.png,.pdf'
          customRequest={() => null}
          fileList={[]}
          multiple={false}
          onChange={handleOnFileChange}
          showUploadList={true}
        >
          <Button
            size='large'
            type='primary'
          >
           + {t('invoice')}
          </Button>
        </Upload>
      ) : (
        <StyledInvoiceUploaderListSpace
          direction='vertical'
          size='small'
        >
          {files.map((file, index) => (
            <Space size='small' key={index}>
              <Space size={5}>
                <FileInvoiceIcon />
                <span>{file.name}</span>
              </Space>
              <Button
                icon={<CloseOutlined />}
                onClick={() => handleRemoveFile(index)}
                size='small'
                type='text'
              />
            </Space>
          ))}
        </StyledInvoiceUploaderListSpace>
      )}

      <Collapse isOpened={error}>
        <Alert message={error} type='error' showIcon />
      </Collapse>
    </StyledInvoiceUploader>
  );
};

InvoiceUploader.propTypes = {
  onChange: PropTypes.func
}

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = {
  batchCreateInvoices: invoicesActions.batchCreateInvoices,
  batchDeleteInvoices: invoicesActions.batchDeleteInvoices,
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceUploader);
